export enum OPPORTUNITY_STATUSES {
  Won = 'won',
  Lost = 'lost',
  Open = 'open',
}
export type OppStatus =
  | OPPORTUNITY_STATUSES.Won
  | OPPORTUNITY_STATUSES.Lost
  | OPPORTUNITY_STATUSES.Open
